/* unplugin-vue-components disabled */import script from "./SelectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectColor.vue?vue&type=script&setup=true&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=9ad7306e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ad7306e"]])

export default __exports__